import { render, staticRenderFns } from "./IsiTeks.vue?vue&type=template&id=91ab1e06&"
import script from "./IsiTeks.vue?vue&type=script&lang=js&"
export * from "./IsiTeks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports